import { UserInfo, Role, ROLE_MENUS } from '../types';

// ============================================================
// 模拟用户数据库（实际对接后端接口时替换）
// ============================================================
const MOCK_USERS: Array<Omit<UserInfo, 'token'> & { password: string }> = [
  {
    id: '1', username: 'superadmin', password: 'admin123',
    name: '超级管理员', role: 'super_admin',
    tenantId: 'root', tenantName: 'CMP平台',
    permissions: ROLE_MENUS['super_admin'],
  },
  {
    id: '2', username: 'admin', password: 'admin123',
    name: '平台管理员', role: 'admin',
    tenantId: 'root', tenantName: 'CMP平台',
    permissions: ROLE_MENUS['admin'],
  },
  {
    id: '3', username: 'agent_sz', password: '123456',
    name: '深圳割草机科技', role: 'agent',
    tenantId: 'tenant_sz', tenantName: '深圳割草机科技',
    permissions: ROLE_MENUS['agent'],
  },
  {
    id: '4', username: 'client_gz', password: '123456',
    name: '广州CPE公司', role: 'client',
    tenantId: 'tenant_gz', tenantName: '广州CPE公司',
    permissions: ROLE_MENUS['client'],
  },
];

export const login = async (username: string, password: string): Promise<UserInfo> => {
  await new Promise(r => setTimeout(r, 600)); // 模拟网络延迟
  const user = MOCK_USERS.find(u => u.username === username && u.password === password);
  if (!user) throw new Error('用户名或密码错误');
  const { password: _, ...rest } = user;
  return { ...rest, token: `mock_token_${user.id}_${Date.now()}` };
};

export const getRoleLabel = (role: Role): string => ({
  super_admin: '超级管理员',
  admin: '平台管理员',
  agent: '代理商',
  client: '终端客户',
}[role]);

export const getRoleColor = (role: Role): string => ({
  super_admin: 'red',
  admin: 'orange',
  agent: 'purple',
  client: 'blue',
}[role]);
